<template>
  <div class="member-order-list">
    <div class="common-header-wrap">
      <mt-header
        :title="this.$t('menu.order_list')"
        class="common-header"
        style="background:#f4c41e;"
        :style="orderNum > 0 ? 'padding-top: 3.7rem !important; top: 0px; height: 8.5rem;' : 'height: 5rem'"
      >
        <!-- <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button> -->
      </mt-header>
    </div>
    <!-- header -->
    <div class='order-header' :style="orderNum > 0 ? '' : 'top: 2rem'">
      <ul :style="orderNum > 0 ? 'padding-top: 0rem;' : 'padding-top: 1rem;'">
        <li
          class="item"
          v-for="item in orderNav"
          v-bind:key="item.id"
          v-bind:class="{ active: item.id === stateType }"
          v-on:click="setOrderNavActive(item.id)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
    >
      <div class="order-body" v-if="orders && orders.length">
        <div v-for="(order, index) in orders" v-bind:key="index">
          <ErrandOrderCard :order="order" @refresh="refreshData()"></ErrandOrderCard>
        </div>
      </div>
      <empty-record v-else-if="orders && !orders.length"></empty-record>
    </div>
  </div>
</template>

<script>
import { getMixOrders, deleteOrder } from '../../../api/memberOrder'
import { addComplaint } from '../../../api/memberO2oCompliant'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import { mapState } from 'vuex'
import EmptyRecord from '../../../components/EmptyRecord'
import { OrderState } from '../../../const/order'
import ErrandOrderCard from '@/components/basic/errand_order_card'

export default {
  components: {
    EmptyRecord,
    ErrandOrderCard
  },
  name: 'MemberOrderList',
  data () {
    return {
      order_id: 0,
      orders: [],
      orderNav: [
        {
          name: this.$t('order.status.all'),
          id: ''
        },
        {
          name: this.$t('order.status.non_payment'),
          id: OrderState.NEW
        },
        {
          name: this.$t('order.status.confirm'),
          id: OrderState.PAY + ',' + OrderState.RECEIPT
        },
        {
          name: this.$t('order.status.pending'),
          id: OrderState.OCCUPY + ',' + OrderState.DELIVER + ',' + OrderState.SEND
        },
        {
          name: this.$t('order.status.no_comment'),
          id: '&no_evaluation=true'
        }
      ],
      stateType: this.$route.query.state ? this.$route.query.state : '',
      orderDetailVisible: false,
      wrapperHeight: 0,
      params: { offset: 0, limit: 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      order_group_list: false
    }
  },
  beforeMount: function () {
    window.addEventListener('closeWebViewModalEvent', (event) => {
      if (event.detail.refresh === 1) {
        this.refreshData()
      }
    })
  },
  mounted () {
    this.wrapperHeight = document.documentElement.clientHeight - 140

    if (!this.user) {
      Toast(this.$t('guest.need_more_please_login'))      
    }
  },
  computed: {
    ...mapState({
      user: state => state.member.info,
      orderNum: state => state.member.orderNum
    })
  },
  methods: {
    refreshData () {
      this.getOrderList(true)
    },
    /**
     * Check the order is errand buy type
     */
    isErrandBuyOrder (order) {
      return order && order.hasOwnProperty('errand_order_type') && order.errand_order_type === 'buy'
    },
    /**
     * Check the order is errand send type
     */
    isErrandSendOrder (order) {
      return (
        order && order.hasOwnProperty('errand_order_type') && order.errand_order_type === 'send'
      )
    },
    complaint (order_id) {
      MessageBox.prompt(this.$t('order.complain_content'), '').then(({ value, action }) => {
        if (value) {
          addComplaint(order_id, 0, value)
            .then(res => {
              Toast(res.message)
              this.$router.push({ name: 'MemberO2oComplaint' })
            })
            .catch(function (error) {
              Toast(error.message)
            })
        }
      })
    },
    setOrderNavActive (index) {
      this.stateType = index

      if (!this.user) {
         Toast(this.$t('guest.need_more_please_login'))
         return
      }
   
      this.getOrderList(true)
    },
    showMessage (message, title) {
      MessageBox.alert(message, title)
    },
    deleteOrder (orderInfo) {
      MessageBox.confirm(this.$t('order.confirm_delete') + '？').then(action => {
        deleteOrder(orderInfo.order_id)
          .then(res => {
            this.getOrderList(true)
          })
          .catch(function (error) {
            Toast(error.message)
          })
      })
    },
    refund (orderId) {
      this.$router.push({ name: 'MemberRefundForm', query: { order_id: orderId } })
    },
    evaluate (orderId) {
      this.$router.push({ name: 'MemberOrderEvaluate', params: { order_id: orderId } })
    },
    pay (paySn) {
      this.$router.push({ name: 'MemberBuyPay', query: { pay_sn: paySn, pay_type: 'pay_new' } })
    },
    getOrderInfo (orderId) {
      this.orderDetailVisible = true
      this.order_id = orderId
    },
    loadMore () {
      // 遊客狀態不去call api
      if (this.user) {
        this.loading = true
        if (this.isMore) {
          this.loading = false
          this.getOrderList(false)
        }
      }
    },
    getOrderList (ifReplace) {
      Indicator.open()
      if (ifReplace) {
        this.loading = false
        this.params.offset = 0
        this.isMore = true
      }
      let params = this.params
      if (this.stateType !== '') {
        params.status = this.stateType
      } else {
        delete params.status
      }
      getMixOrders(params)
        .then(res => {
          if (res.result.length === 0) {
            this.isMore = false
            this.params.offset = this.params.offset - 1
          } else {
            this.isMore = true
            this.params.offset = this.params.offset + 1
          }
          const data = res.result
          if (ifReplace) {
            this.orders = data
          } else {
            this.orders = this.orders.concat(data)
          }
        })
        .catch(err => {
          this.$alert.error(err.message)
          console.error('Mix Orders Error Response', err)
        })
        .finally(() => {
          Indicator.close()
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.member-order-list {
  .order-header {
    position: fixed;
    height: 2rem;
    width: 100%;
    z-index: 100;
    ul {
      list-style: none;
      width: auto;
      display: flex;
      justify-content: space-around;
      align-content: center;
      align-items: center;
      // height: 100%;
      // padding-bottom: 25px;
      // border-radius: 0 0 30px 30px;
      // background: #f4c41e;
      // border-bottom: 1px solid #e8eaed;

      li {
        font-size: 0.72rem;
        color: white;
        font-weight: bold;
        height: 100%;
        text-align: center;
        line-height: 1.4rem;
        // width: 7.5rem;
        // background-color: #DD2C35;
        // box-shadow: 0px 2px 0px 0px #b22433;
        // border-radius: 6px;
        letter-spacing: 3px;
        border-bottom: 0.1rem solid transparent;
        &.active {
          // background-color: #B22433;
          // color: white;
          color: black;
          border-bottom: 0.1rem solid black;
          // color: $primaryColor;
          // border-bottom-color: $primaryColor;
        }
      }
    }
  }
  .order-body {
    position: relative;
    padding-top: 0.5rem;
    padding-bottom: $footerHeightFull;
    .list {
      width: 100%;
      margin-top: 0.55rem;
      .tips-body {
        height: 2.2rem;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 1px 0 0 rgba(232, 234, 237, 1);
        display: flex;
        justify-content: space-between;
        padding: 0 0.75rem 0 0.5rem;
        .tips {
          font-size: 0.7rem;
          color: #333333;
          line-height: 2.2rem;
        }
        .statusTips {
          color: #666666;
        }
        img {
          width: 3.8rem;
          height: 3rem;
        }
      }
      .order-image {
        height: 4.5rem;
        background: rgba(250, 250, 250, 1);
        width: 100%;
        overflow: auto;
        white-space: nowrap;
        .goods_info {
          height: 4rem;
          margin-bottom: 0.5rem;
          .img {
            width: 3rem;
            height: 3rem;
            float: left;
            margin: 0.85rem 0.3rem 0.5rem;
            img {
              width: 3rem;
              height: 3rem;
              border-radius: 1px;
            }
          }
          .info {
            width: 13rem;
            font-size: 0.7rem;
            color: #4e545d;
            line-height: 1rem;
            margin-top: 0.85rem;
            margin-right: 0.75rem;
            float: right;
            text-align: right;
            .goods_name {
              white-space: normal;
              overflow: hidden;
              height: 2rem;
            }
          }
        }
      }
      .multiple {
        .imagebox {
          width: 100%;
          overflow-x: auto;
          white-space: nowrap;
          img {
            width: 3rem;
            height: 3rem;
            margin: 0.85rem 0.3rem 0.5rem;
            display: inline-block;
          }
        }
      }
      .price {
        font-size: 0.7rem;
        color: rgba(78, 84, 93, 1);
        line-height: 2.2rem;
        height: 2.2rem;
        background-color: #fff;
        padding: 0 0.75rem 0 0;
        border-bottom: 1px solid #e8eaed;
        box-sizing: border-box;
        text-align: right;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        i {
          font-size: 0.9rem;
          padding-left: 0.25rem;
          font-style: normal;
          &.freight {
            color: rgba(124, 127, 136, 1);
            font-size: 0.6rem;
          }
        }
      }
    }
    .loading-wrapper {
      text-align: center;
      p {
        color: #c3c3c3;
        font-size: 0.6rem;
        margin: 0.5rem auto;
      }
    }
  }
  .mint-popup {
    width: 100%;
    height: 11.75rem;
  }
}
.order-list-opratio {
  height: 2.2rem;
  display: flex;
  justify-content: flex-end;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.1rem;
}
.order-list-opratio button {
  width: 4.5rem;
  height: 1.5rem;
  font-size: 0.7rem;
  border-radius: 0.7rem;
  margin: 0.35rem 0.75rem 0.35rem 0;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.05);
}
.order-list-opratio .line_red {
  background-color: #fff;
  color: #f2270c;
  border: 1px solid #f2270c;
  box-shadow: 0 3px 6px 0 rgba(242, 39, 12, 0.1);
}
</style>

<style scoped>
.order-header {
  top: 6.5rem;
}
.common-header {
  padding-top: 0px !important;
}
.common-header >>> .mint-header-title {
  margin-bottom: 15px !important;
}
</style>
